export default __webpack_public_path__ + "static/media/Jack.ddb76cc4.jpeg";